export function client(data) {
    const { own_variants, save_own_variants } = data;

    return {
        custom: own_variants,
        saveCustom: save_own_variants,
    };
}

export function server(data) {
    const { custom, saveCustom } = data;
    return {
        own_variants: custom ? 1 : 0,
        save_own_variants: saveCustom ? 1 : 0,
    };
}
